import { render, staticRenderFns } from "./MediaFormModal.vue?vue&type=template&id=3984a032&scoped=true&"
import script from "./MediaFormModal.vue?vue&type=script&lang=js&"
export * from "./MediaFormModal.vue?vue&type=script&lang=js&"
import style0 from "./MediaFormModal.vue?vue&type=style&index=0&id=3984a032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3984a032",
  null
  
)

export default component.exports